import { supabase, isSupabaseConfigured } from './supabase';
import manifest from '../data/portfolioManifest.json';

// Härled initialer för avatarcirkeln, t.ex.
// "Maria Holmberg Simes" -> "M", "Sonja och Alexander Asalok" -> "S&A".
export const reviewInitials = (name = '') => {
  const parts = name.split(/\s+och\s+|\s*&\s*/i).filter(Boolean);
  if (parts.length > 1) return parts.map((p) => p.trim()[0]).join('&').toUpperCase();
  return (name.trim()[0] || '?').toUpperCase();
};

export const fallbackReviews = manifest.reviews.map((r, i) => ({
  id: `f-review-${i}`,
  name: r.name,
  tag: r.tag,
  quote: r.quote,
  rating: r.rating || 5,
  sortOrder: i,
}));

const mapRow = (row) => ({
  id: row.id,
  name: row.name,
  tag: row.tag || '',
  quote: row.quote,
  rating: row.rating ?? 5,
  sortOrder: row.sort_order ?? 0,
});

// Besökarvy – med fallback.
export const fetchReviews = async () => {
  if (!isSupabaseConfigured) return fallbackReviews;
  try {
    const imgs = await listReviews();
    return imgs.length ? imgs : fallbackReviews;
  } catch (err) {
    console.error('Kunde inte hämta recensioner:', err.message);
    return fallbackReviews;
  }
};

export const listReviews = async () => {
  if (!isSupabaseConfigured) return [];
  const { data, error } = await supabase
    .from('reviews')
    .select('*')
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: true });
  if (error) throw error;
  return (data || []).map(mapRow);
};

export const addReview = async ({ name, tag = '', quote, rating = 5 }) => {
  if (!isSupabaseConfigured) throw new Error('Supabase är inte konfigurerat.');
  const { data, error } = await supabase
    .from('reviews')
    .insert({ name, tag, quote, rating, sort_order: Date.now() })
    .select()
    .single();
  if (error) throw error;
  return mapRow(data);
};

export const updateReview = async (id, patch) => {
  if (!isSupabaseConfigured) throw new Error('Supabase är inte konfigurerat.');
  const dbPatch = {};
  if (patch.name !== undefined) dbPatch.name = patch.name;
  if (patch.tag !== undefined) dbPatch.tag = patch.tag;
  if (patch.quote !== undefined) dbPatch.quote = patch.quote;
  if (patch.rating !== undefined) dbPatch.rating = patch.rating;
  const { error } = await supabase.from('reviews').update(dbPatch).eq('id', id);
  if (error) throw error;
};

export const deleteReview = async (id) => {
  if (!isSupabaseConfigured) throw new Error('Supabase är inte konfigurerat.');
  const { error } = await supabase.from('reviews').delete().eq('id', id);
  if (error) throw error;
};
